import { Header } from "../../components/Header/Header";
import { useLocation } from "react-router-dom";
import React from "react";
import { RegisterForm } from "./components/RegisterForm";
import { ActivationForm } from "./components/ActivationForm";

const RegisterPage = () => {
  const location = useLocation();
  const isActivation = location.pathname.includes("activate");

  return (
    <div className="min-h-screen bg-gray-50">
      <Header minimal />
      <div className="container mx-auto px-4 py-12">
        {isActivation ? <ActivationForm /> : <RegisterForm />}
      </div>
    </div>
  );
};

export default RegisterPage;
